import { Quiz } from "@/model/quiz.model";
import { QuizService } from "../quiz.interface";

export class QuizServiceMock implements QuizService {
    async saveQuiz(quiz: Quiz): Promise<void> {
        console.log("SAVED", quiz)
    }
    
}